/* Batterivelger — dependency-free wizard over assets/battery-finder-data.json.
 * State {use, voltage, ah, maxl, maxw, maxh, terminal} mirrors location.hash
 * (shareable links, back button works). Result cards lazy-fetch
 * /products/{handle}.js for LIVE price/availability — the weekly JSON never
 * carries price, so there is no stale-price failure mode. 404 hides the card.
 */
(function () {
  'use strict';

  var root = document.getElementById('pv-bf');
  if (!root) return;

  var wizard = document.getElementById('pv-bf-wizard');
  var stepVoltage = document.getElementById('pv-bf-step-voltage');
  var stepSize = document.getElementById('pv-bf-step-size');
  var stepTerminal = document.getElementById('pv-bf-step-terminal');
  var resultsWrap = document.getElementById('pv-bf-results-wrap');
  var heading = document.getElementById('pv-bf-results-heading');
  var grid = document.getElementById('pv-bf-grid');
  var moreBtn = document.getElementById('pv-bf-more');
  var emptyBox = document.getElementById('pv-bf-empty');
  var stickybar = document.getElementById('pv-bf-stickybar');
  var showBtn = document.getElementById('pv-bf-show');
  var countEl = document.getElementById('pv-bf-count');
  var resetBtn = document.getElementById('pv-bf-reset');

  var PAGE = 24;
  var TERMINAL_USES = { bil: 1, mc: 1, traktor: 1 };
  var USE_NAMES = { bobil: 'bobil', 'båt': 'båt', mc: 'MC', bil: 'bil',
                    traktor: 'traktor', solcelle: 'solcelle/hytte', ups: 'UPS' };

  var batteries = [];
  var shown = PAGE;
  var priceCache = {};
  var applyingHash = false;

  fetch(root.dataset.jsonUrl, { cache: 'no-cache' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (data) {
      batteries = data.batteries || [];
      wizard.hidden = false;
      readHash();
      render();
    })
    .catch(function () { /* wizard stays hidden; fallback categories carry the page */ });

  /* ---------- state <-> hash ---------- */

  function state() {
    var s = {};
    var f = wizard.elements;
    s.use = (f.use.value || '');
    s.voltage = f.voltage.value || '';
    s.ah = f.ah.value || '';
    s.maxl = f.maxl.value || '';
    s.maxw = f.maxw.value || '';
    s.maxh = f.maxh.value || '';
    s.terminal = f.terminal.value || '';
    return s;
  }

  function writeHash() {
    if (applyingHash) return;
    var s = state();
    var parts = [];
    Object.keys(s).forEach(function (k) { if (s[k]) parts.push(k + '=' + encodeURIComponent(s[k])); });
    var next = parts.length ? '#' + parts.join('&') : '#';
    if (('#' + (location.hash.replace(/^#/, ''))) !== next) {
      // pushState-free: assigning location.hash creates a history entry
      location.hash = next;
    }
  }

  function readHash() {
    var raw = location.hash.replace(/^#/, '');
    var s = {};
    raw.split('&').forEach(function (kv) {
      var i = kv.indexOf('=');
      if (i > 0) s[kv.slice(0, i)] = decodeURIComponent(kv.slice(i + 1));
    });
    applyingHash = true;
    setRadio('use', s.use || '');
    setRadio('voltage', s.voltage || '');
    setRadio('ah', s.ah || '');
    setRadio('terminal', s.terminal || '');
    wizard.elements.maxl.value = /^\d+$/.test(s.maxl || '') ? s.maxl : '';
    wizard.elements.maxw.value = /^\d+$/.test(s.maxw || '') ? s.maxw : '';
    wizard.elements.maxh.value = /^\d+$/.test(s.maxh || '') ? s.maxh : '';
    var dims = root.querySelector('.pv-bf__dims');
    if (dims && (wizard.elements.maxl.value || wizard.elements.maxw.value || wizard.elements.maxh.value)) {
      dims.open = true;
    }
    applyingHash = false;
  }

  function setRadio(name, value) {
    var list = wizard.querySelectorAll('input[name="' + name + '"]');
    var hit = false;
    list.forEach(function (r) { r.checked = (r.value === value); hit = hit || r.checked; });
    if (!hit) list.forEach(function (r) { if (r.value === '') r.checked = true; });
  }

  /* ---------- filtering ---------- */

  function ahRange(v) {
    if (!v) return null;
    var m = v.match(/^(\d+)-(\d*)$/);
    if (!m) return null;
    return [parseInt(m[1], 10), m[2] ? parseInt(m[2], 10) : Infinity];
  }

  function filtered() {
    var s = state();
    if (!s.use) return null;
    var r = ahRange(s.ah);
    var v = s.voltage ? parseInt(s.voltage, 10) : null;
    var maxl = parseInt(s.maxl, 10) || null;
    var maxw = parseInt(s.maxw, 10) || null;
    var maxh = parseInt(s.maxh, 10) || null;
    var term = TERMINAL_USES[s.use] ? s.terminal : '';
    return batteries.filter(function (b) {
      if (b.use.indexOf(s.use) === -1) return false;
      if (v !== null && b.voltage !== v) return false;
      if (r && !(b.ah >= r[0] && b.ah < r[1])) return false;
      // footprint: a battery can be rotated 90°, so accept either orientation
      // (24 products have w > l in supplier data — OPzV cells etc.)
      if (maxl || maxw) {
        var L = maxl || Infinity, W = maxw || Infinity;
        if (!((b.l <= L && b.w <= W) || (b.l <= W && b.w <= L))) return false;
      }
      if (maxh && b.h > maxh) return false;
      if (term && (!b.terminal || b.terminal.indexOf(term) === -1)) return false;
      return true;
    });
  }

  /* ---------- rendering ---------- */

  function render() {
    var s = state();
    var list = filtered();

    stepVoltage.hidden = !s.use;
    stepSize.hidden = !s.use;
    stepTerminal.hidden = !s.use || !TERMINAL_USES[s.use];
    resetBtn.hidden = !s.use;
    if (stepTerminal.hidden) setRadio('terminal', '');

    if (!list) {
      resultsWrap.hidden = true;
      stickybar.hidden = true;
      return;
    }

    // per-voltage counts for the current use (hide voltage classes with 0 hits)
    var byVolt = {};
    batteries.forEach(function (b) {
      if (b.use.indexOf(s.use) !== -1) byVolt[b.voltage] = (byVolt[b.voltage] || 0) + 1;
    });
    stepVoltage.querySelectorAll('[data-voltage]').forEach(function (chip) {
      var n = byVolt[parseInt(chip.dataset.voltage, 10)] || 0;
      chip.hidden = n === 0;
      chip.querySelector('span').textContent = chip.dataset.voltage + 'V (' + n + ')';
    });

    countEl.textContent = list.length;
    stickybar.hidden = list.length === 0;
    resultsWrap.hidden = false;
    emptyBox.hidden = list.length !== 0;
    heading.textContent = list.length
      ? list.length + ' batterier til ' + (USE_NAMES[s.use] || s.use)
      : '';

    grid.innerHTML = '';
    list.slice(0, shown).forEach(function (b) { grid.appendChild(card(b)); });
    moreBtn.hidden = list.length <= shown;
    if (!moreBtn.hidden) {
      moreBtn.textContent = 'Vis flere (' + (list.length - shown) + ' igjen)';
    }
    observePrices();
  }

  function card(b) {
    var li = document.createElement('li');
    li.className = 'pv-bf__item card-wrapper';
    li.dataset.handle = b.handle;
    var badges = '';
    if (!b.available) badges += '<span class="pv-bf__badge pv-bf__badge--oos">' + (document.documentElement.lang === 'sv' ? 'Slut i lager' : 'Utsolgt') + '</span>';
    if (b.b2b) badges += '<span class="pv-bf__badge pv-bf__badge--b2b">Kun bedrift</span>';
    var specs = [b.voltage + 'V', fmtAh(b.ah) + ' Ah', b.chem,
                 b.l + '×' + b.w + '×' + b.h + ' mm'];
    if (b.cca) specs.push(b.cca + ' CCA');
    if (b.terminal) specs.push('+' + b.terminal.split(',')[0]);
    li.innerHTML =
      '<div class="card pv-bf__card">' +
        '<a class="pv-bf__cardlink full-unstyled-link" href="/products/' + b.handle + '">' +
          '<div class="pv-bf__media">' +
            (b.img ? '<img src="' + b.img + '" loading="lazy" alt="" width="180" height="180">' : '') +
            badges +
          '</div>' +
          '<div class="card__content pv-bf__content">' +
            '<h3 class="card__heading pv-bf__title">' + esc(b.title) + '</h3>' +
            '<div class="tech-badge-container">' +
              specs.map(function (t) { return '<span class="tech-badge-item">' + esc(t) + '</span>'; }).join('') +
            '</div>' +
            '<div class="pv-bf__price" data-price>&nbsp;</div>' +
          '</div>' +
        '</a>' +
      '</div>';
    return li;
  }

  function fmtAh(v) { return (v % 1 === 0) ? String(v) : String(v).replace('.', ','); }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- live price (lazy, only for visible cards) ---------- */

  var io = null;
  function observePrices() {
    if (io) io.disconnect();
    if (!('IntersectionObserver' in window)) {
      grid.querySelectorAll('.pv-bf__item').forEach(loadPrice);
      return;
    }
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); loadPrice(e.target); }
      });
    }, { rootMargin: '200px' });
    grid.querySelectorAll('.pv-bf__item').forEach(function (el) { io.observe(el); });
  }

  function loadPrice(el) {
    var handle = el.dataset.handle;
    var slot = el.querySelector('[data-price]');
    if (!slot) return;
    if (priceCache[handle]) { applyPrice(el, slot, priceCache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (r.status === 404) { el.remove(); return null; }
        if (!r.ok) return null;
        return r.json();
      })
      .then(function (p) {
        if (!p) return;
        priceCache[handle] = p;
        applyPrice(el, slot, p);
      })
      .catch(function () { /* leave card without price */ });
  }

  function applyPrice(el, slot, p) {
    var kr = Math.round(p.price / 100).toLocaleString('nb-NO');
    slot.innerHTML = '<strong>' + kr + ' kr</strong> <small>inkl. mva</small>';
    // live availability corrects the week-old JSON flag BOTH ways: add the
    // badge when live says sold out, remove a stale one when it's back in stock
    var badge = el.querySelector('.pv-bf__badge--oos');
    if (!p.available) {
      el.classList.add('pv-bf__item--oos');
      if (!badge) {
        var b = document.createElement('span');
        b.className = 'pv-bf__badge pv-bf__badge--oos';
        b.textContent = 'Utsolgt';
        el.querySelector('.pv-bf__media').appendChild(b);
      }
    } else {
      el.classList.remove('pv-bf__item--oos');
      if (badge) badge.remove();
    }
  }

  /* usage insight: harmless no-op unless GTM/dataLayer is configured */
  function track(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, data || {}));
    } catch (e) { /* never break the wizard for analytics */ }
  }

  /* ---------- events ---------- */

  wizard.addEventListener('change', function (e) {
    shown = PAGE;
    writeHash();
    render();
    if (e.target && e.target.name === 'use' && e.target.value) {
      track('batterivelger_use', { bruksomrade: e.target.value });
    }
  });
  grid.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('.pv-bf__item');
    if (item) {
      var s = state();
      track('batterivelger_klikk', { handle: item.dataset.handle, bruksomrade: s.use,
                                     spenning: s.voltage, kapasitet: s.ah });
    }
  });
  var dimTimer = null;
  wizard.addEventListener('input', function (e) {
    if (e.target.type !== 'number') return;
    clearTimeout(dimTimer);
    dimTimer = setTimeout(function () { shown = PAGE; writeHash(); render(); }, 350);
  });
  wizard.addEventListener('submit', function (e) { e.preventDefault(); });

  moreBtn.addEventListener('click', function () {
    shown += PAGE;
    render();
  });

  showBtn.addEventListener('click', function () {
    resultsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  resetBtn.addEventListener('click', function () {
    wizard.reset();
    setRadio('use', '');
    shown = PAGE;
    writeHash();
    render();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('hashchange', function () {
    readHash();
    shown = PAGE;
    render();
  });
})();
